import { render, staticRenderFns } from "./BSwitch.vue?vue&type=template&id=ab1281d6"
import script from "./BSwitch.vue?vue&type=script&lang=ts"
export * from "./BSwitch.vue?vue&type=script&lang=ts"
import style0 from "./BSwitch.vue?vue&type=style&index=0&id=ab1281d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports